var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.token && _vm.viewRoute)?_c('v-container',{staticClass:"container-dashboard",attrs:{"fluid":""}},[_c('tableau-viz',{staticClass:"container-dashboard",attrs:{"id":"tableauViz","src":`${_vm.server}/#/site/${_vm.site}/views/${_vm.viewRoute}`,"token":_vm.token}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }